/**
 * Error skips any error reporting and user prompting. Used in case api returned
 * error and api is already sending error data to sentry.
 */
export class ApiAlreadyNotified extends Error {
  constructor() {
    super('Ignore sentry error');
    Object.setPrototypeOf(this, ApiAlreadyNotified.prototype);
  }
}
